import type { FieldMetaData } from "./fieldsMetaData";

const createFieldMetaData = (
    isEmpty: boolean,
    hidden: boolean,
    editDisabled: boolean,
): FieldMetaData => ({
    // isEmpty,
    // hidden,
    // editDisabled,
    fields: () => ({ isEmpty, hidden, editDisabled }),
});

export { createFieldMetaData };